import { useCallback, useEffect, useState } from "react";
import { InvoiceResponse } from "../types/sale.type";
import { getInvoiceDetail } from "../services";
import { Link, useParams, useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InvoiceDetails from "../components/Sales/Invoice/Details";
import DocumentSkeleton from "../components/Sales/Invoice/Details/Skeleton";
import VersionSelector from "../components/Sales/VersionSelector";
import { salesListReturnPath } from "../components/Sales/salesListUrl";
import { useTransactionVersions } from "../utils/hooks/useTransactionVersions";

export default function InvoiceDetailsPage() {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const [searchParams] = useSearchParams();
  const [invoice, setInvoice] = useState<InvoiceResponse>();
  const [triggerFetch, setTriggerFetch] = useState<number>(0);
  const { versions, selected, setSelected, versionParam } =
    useTransactionVersions(invoiceId);

  const getInvoiceDetails = useCallback(
    async (invoiceId: string, version?: number) => {
      const {
        data: { data },
      } = await getInvoiceDetail(invoiceId, version);
      setInvoice(data);
    },
    [],
  );

  useEffect(() => {
    invoiceId && getInvoiceDetails(invoiceId, versionParam);
  }, [triggerFetch, invoiceId, versionParam, getInvoiceDetails]);

  if (!invoice) return <DocumentSkeleton />;

  const salesListPath = salesListReturnPath(searchParams);

  return (
    <Box sx={{ padding: "8px 0" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
          <Link
            to={salesListPath}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Typography variant="body1" sx={{ fontWeight: 500 }}>
              การขาย
            </Typography>
          </Link>
          <Typography variant="body1" sx={{ mx: 1 }}>
            /
          </Typography>
          <Typography variant="body1" color="primary">
            {invoice.invoice_no}
          </Typography>
        </Box>
        <VersionSelector
          versions={versions}
          selected={selected}
          onChange={setSelected}
        />
      </Box>
      <InvoiceDetails invoice={invoice} setTriggerFetch={setTriggerFetch} />
    </Box>
  );
}
